/* eslint-disable no-plusplus */
/* eslint-disable no-alert */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useCallback, useEffect, useState } from 'react';
import Logo from 'assets/images/logo-conlicitacao-dark.png';
import Select from 'react-select';
import InputMask from 'react-input-mask';
import { RolesOption, RolesOptions } from 'services/roles';
import ModalActivities from 'components/atoms/modal_activities';
import ModalStates from 'components/atoms/modal_states';
import DOMPurify from 'dompurify';
import {
  met_conlicitacao,
  billing,
  description_services_conlicitacao,
  average_participation_bidding,
  employee_quantity,
  RegistrationQuestionsOption,
} from 'services/registration_questions';
import { validateCnpj } from 'utils/cnpj';
import {
  countryCodeSafeMaskProps,
  isCelularValid,
  isTelefoneValid,
  maskBrPhone,
  splitBrPhone,
} from 'utils/phone';

import { useDispatch, useSelector } from 'react-redux';
import { register } from 'store/modules/profile_store/actions';
import { buildTracking } from 'services/tracking_params';
import { ProfileState } from 'store/modules/profile_store/types';
import { ApplicationState } from 'store';
import { useLocation } from 'react-router-dom';
import { Container } from './styles';

const RegisterView = () => {
  const dispatch = useDispatch();
  const queryString = window.location.search;
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showModalState, setShowModalState] = useState<boolean>(false);
  const [fullName, setFullName] = useState<string>('');
  const [cel, setCel] = useState<string>('');
  const [telephone, setTelephone] = useState<string>('');
  const [roles, setRoles] = useState<RolesOption[]>([]);
  const [email, setEmail] = useState<string>('');
  const [confirmEmail, setConfirmEmail] = useState<string>('');
  const [cnpj, setCnpj] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const [descricaoAtividades, setDescricaoAtividades] = useState<string>('');
  const [atividadesName, setAtividadesName] = useState<string>('');
  const [atividadesIds, setAtividadesIds] = useState<Array<string>>([]);
  const [selectedStates, setSelectedStates] = useState<Array<string>>([]);
  const [employeeQuantity, setEmployeeQuantity] = useState<Array<RegistrationQuestionsOption>>([]);
  const [metConlicitacao, setMetConlicitacao] = useState<Array<RegistrationQuestionsOption>>([]);
  const [averageBilling, setAverageBilling] = useState<Array<RegistrationQuestionsOption>>([]);
  const [averageBidding, setAverageBidding] = useState<Array<RegistrationQuestionsOption>>([]);
  const [descriptionService, setDescriptionService] = useState<string>('');
  const [descriptionUseService, setDescriptionUseService] = useState<string>('');
  const { register_request } = useSelector<ApplicationState, ProfileState>(
    (state) => state.storage.profile,
  );
  const [isValidCnpj, setIsValidCnpj] = useState(true);
  const [celIsValid, setCelIsValid] = useState<boolean>(true);
  const [telephoneIsValid, setTelephoneIsValid] = useState<boolean>(true);
  const [NameIsValid, setNameIsValid] = useState<boolean>(true);
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [emailIsValid, setEmailIsValid] = useState(true);
  const [passwordIsValid, setPasswordIsValid] = useState(true);
  const [stateIsValid, setStateIsValid] = useState(true);
  const [signupSucess, setSignupSucess] = useState<boolean>(false);
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const utmId = query.get('utm_id');
  const urlCnpj = query.get('cnpj');
  const urlNome = query.get('nome');
  const urlEmail = query.get('email');
  const urlWhatsapp = query.get('whatsapp');
  const [roleIsValid, setRoleIsValid] = useState(true);
  // DDD e número saem do valor já normalizado (sem código do país), e não de um
  // regex sobre o texto mascarado: um "+55" colado desloca a máscara e jogaria o
  // 55 no DDD, perdendo os últimos dígitos do número.
  const celular = splitBrPhone(cel);
  const telefoneEmpresa = splitBrPhone(telephone);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const activitiesValid = atividadesIds.length > 0 || descricaoAtividades.length > 0;

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const nameRegex = /^[A-Za-zÀ-ÿ' ]{3,80}$/;
  const cnpjRegex = /^[0-9A-Za-z]{2}\.[0-9A-Za-z]{3}\.[0-9A-Za-z]{3}\/[0-9A-Za-z]{4}-\d{2}$/;
  const [formError, setFormError] = useState<string>('');

  const validateEmails = () => {
    if (email !== confirmEmail) {
      setEmailError('Os e-mails não coincidem');
    } else {
      setEmailError('');
    }
  };

  const validatePasswordConfirmation = useCallback(
    (passwordValue: string, confirmPasswordValue: string) => {
      if (passwordValue !== confirmPasswordValue) {
        setPasswordError('As senhas não coincidem');
      } else {
        setPasswordError('');
      }
    },
    [],
  );

  useEffect(() => {
    if (urlNome) setFullName(urlNome);
    if (urlEmail) {
      setEmail(urlEmail);
      setConfirmEmail(urlEmail);
    }

    if (urlCnpj) setCnpj(urlCnpj);
    // Aceita o parâmetro com ou sem código do país (`5511...`): antes, um valor
    // internacional simplesmente não preenchia o campo.
    if (urlWhatsapp && isCelularValid(urlWhatsapp)) {
      setCel(maskBrPhone(urlWhatsapp));
    }
  }, [urlNome, urlEmail, urlCnpj, urlWhatsapp]);

  const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setPassword(value);
    validatePasswordConfirmation(value, confirmPassword);
    setPasswordIsValid(passwordRegex.test(value));
  };

  const handleConfirmPasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setConfirmPassword(e.target.value);
    validatePasswordConfirmation(password, e.target.value);
  };

  useEffect(() => {
    validateEmails();
  }, [email, confirmEmail]);

  useEffect(() => {
    register_request?.loaded && signupSucess && window.location.replace(`/signup=new`);
  }, [register_request?.loaded]);

  function isCnpjValid(cnpj: string): boolean {
    return validateCnpj(cnpj);
  }

  const handleCnpjBlur = () => {
    setIsValidCnpj(isCnpjValid(cnpj));
  };

  const validateField = (
    value: string | Array<string> | Array<RolesOption>,
    minLength: number,
    setState: (value: React.SetStateAction<boolean>) => void,
  ) => {
    const isValid = value.length >= minLength;
    setState(isValid);
    return isValid;
  };

  const validateForm = () => {
    // Contagem de DÍGITOS (11 no celular, 10 no fixo), não de caracteres da string
    // mascarada — que passava mesmo com o número deslocado pelo código do país.
    const celValid = isCelularValid(cel);
    setCelIsValid(celValid);

    const telephoneValid = isTelefoneValid(telephone);
    setTelephoneIsValid(telephoneValid);

    const NameValid = validateField(fullName, 9, setNameIsValid);
    const EmailValid = validateField(email, 7, setEmailIsValid);
    const PasswordValid = validateField(password, 5, setPasswordIsValid);
    const StateValid = validateField(selectedStates, 1, setStateIsValid);
    const RoleValid = validateField(roles, 1, setRoleIsValid);

    const cnpjValid = isCnpjValid(cnpj);

    const emailFormatValid = emailRegex.test(email);
    const nameFormatValid = nameRegex.test(fullName);
    const cnpjFormatValid = cnpjRegex.test(cnpj);

    if (!emailFormatValid) setEmailError('Formato de e-mail inválido');
    if (!nameFormatValid) setNameIsValid(false);
    if (!cnpjFormatValid) setIsValidCnpj(false);

    const isFormValid =
      celValid &&
      telephoneValid &&
      cnpjValid &&
      cnpjFormatValid &&
      NameValid &&
      nameFormatValid &&
      EmailValid &&
      emailFormatValid &&
      PasswordValid &&
      StateValid &&
      RoleValid &&
      isValidCnpj &&
      activitiesValid;

    return isFormValid;
  };

  const clean = (v: string) => DOMPurify.sanitize(v.trim());

  const handleClick = async () => {
    setFormSubmitted(true);
    if (validateForm()) {
      const params = {
        site_key: 'cadastro_cnl',
        conversion_identifier: 'cadastro-etapa-1',
        contact: {
          nome: clean(fullName),
          cargo_id: roles,
          numero_celular: celular.numero,
          ddd_celular: celular.ddd,
          email: clean(email.toLowerCase()),
          senha: password,
        },
        client: {
          numero_telefone: telefoneEmpresa.numero,
          ddd_telefone: telefoneEmpresa.ddd,
          cnpj,
          url_params: clean(queryString.slice(1)),
        },
        filter_options: {
          activities_ids: atividadesIds,
          states_initials: selectedStates.toString(),
        },
        others: {
          met_conlicitacao: clean(metConlicitacao as any),
          description_services_conlicitacao: clean(descriptionService),
          description_use_service: clean(descriptionUseService),
          average_participation_bidding: clean(averageBidding as any),
          employee_quantity: clean(employeeQuantity as any),
          billing_value: clean(averageBilling as any),
        },
        described: {
          activities: clean(descricaoAtividades),
        },
        tracking: buildTracking(),
      };

      setFormError('');
      dispatch(register(params));
      setSignupSucess(true);
    } else {
      setFormError('Por favor, preencha todos os campos obrigatórios corretamente.');
    }
  };
  return (
    <Container>
      <div className="container">
        <div className="row">
          <div className="col-md-9 col-12 mx-auto">
            <div className="text-center my-3">
              <img
                src={Logo}
                alt="ConLicitação"
                className="my-3"
                style={{ width: '300px', height: 'auto' }}
                width="300"
                height="auto"
              />
            </div>
            <div className="card mt-4 p-md-3 p-0 mb-5">
              <div className="card-body">
                <h3>Cadastre-se</h3>
                {formError && (
                  <div className="alert alert-danger text-center py-2 mt-3" role="alert">
                    {formError}
                  </div>
                )}
                <h6 className="card-subtitle my-2">
                  Experimente todas as ferramentas do ConLicitação por{' '}
                  <strong>
                    {utmId && utmId.startsWith('parceiro') ? '30' : '15'} dias gratuitos
                  </strong>
                </h6>
                <p className="card-text font-weight-bold mt-4">Dados do contato</p>
                <div className="row">
                  <div className="col-md-6 mb-4">
                    <label htmlFor="fullName">Nome completo</label>
                    <input
                      type="text"
                      className={`form-control ${!NameIsValid ? 'is-invalid' : ''}`}
                      id="fullName"
                      value={fullName}
                      onChange={(e) => setFullName(DOMPurify.sanitize(e.target.value))}
                    />
                    {!NameIsValid && (
                      <div className="invalid-feedback">Digite seu nome completo</div>
                    )}
                  </div>
                  <div className="col-md-6 mb-4">
                    <label htmlFor="role">Cargo</label>
                    <Select
                      name="role"
                      className={`${!roleIsValid ? 'is-invalid' : ''}`}
                      options={RolesOptions}
                      getOptionValue={(option) => option.value}
                      noOptionsMessage={() => 'Selecionar'}
                      placeholder="Selecionar"
                      onChange={(selected) => {
                        setRoles(selected?.value as any);
                      }}
                    />
                    {!roleIsValid && <div className="invalid-feedback">Campo obrigatório.</div>}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 mb-4">
                    <label htmlFor="cel">Celular</label>
                    <InputMask
                      {...countryCodeSafeMaskProps}
                      mask="(99) 99999-9999"
                      className={`form-control ${!celIsValid ? 'is-invalid' : ''}`}
                      id="cel"
                      value={cel}
                      onChange={(e) => {
                        setCel(e.target.value);
                      }}
                    />
                    {!celIsValid && <div className="invalid-feedback">Campo obrigatório.</div>}
                  </div>
                  <div className="col-md-6 mb-4">
                    <label htmlFor="telephone">Telefone empresarial</label>
                    <InputMask
                      {...countryCodeSafeMaskProps}
                      mask="(99) 9999-9999"
                      className={`form-control ${!telephoneIsValid ? 'is-invalid' : ''}`}
                      id="telephone"
                      value={telephone}
                      onChange={(e) => setTelephone(e.target.value)}
                    />
                    {!telephoneIsValid && (
                      <div className="invalid-feedback">Campo obrigatório.</div>
                    )}
                  </div>
                </div>
                <p className="card-text font-weight-bold mt-4">Dados da conta</p>
                <div className="row">
                  <div className="col-md-6 mb-4">
                    <label htmlFor="email">E-mail</label>
                    <input
                      type="email"
                      className={`form-control ${!emailIsValid ? 'is-invalid' : ''}`}
                      id="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  <div className="col-md-6 mb-4">
                    <label htmlFor="confirmEmail">Confirmar e-mail</label>
                    <input
                      type="email"
                      className="form-control"
                      id="confirmEmail"
                      onPaste={(e: React.ClipboardEvent<HTMLInputElement>) => e.preventDefault()}
                      value={confirmEmail}
                      onChange={(e) => setConfirmEmail(e.target.value)}
                    />
                    {emailError && <small className="text-danger">{emailError}</small>}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 mb-4">
                    <label htmlFor="cnpj">CNPJ</label>
                    <InputMask
                      mask="**.***.***/****-99"
                      className={`form-control ${isValidCnpj ? '' : 'is-invalid'}`}
                      id="cnpj"
                      value={cnpj}
                      onBlur={handleCnpjBlur}
                      onChange={(e) => setCnpj(e.target.value.toUpperCase())}
                    />
                    {!isValidCnpj && (
                      <div className="invalid-feedback">
                        O CNPJ inserido é inválido. Por favor, insira um CNPJ válido.
                      </div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 mb-4">
                    <label htmlFor="password">Escolha uma senha</label>
                    <input
                      type="password"
                      className={`form-control ${passwordIsValid ? '' : 'is-invalid'}`}
                      id="password"
                      value={password}
                      onChange={handlePasswordChange}
                    />
                    {!passwordIsValid && (
                      <div className="invalid-feedback">
                        A senha deve ter no mínimo 8 caracteres, incluindo número e símbolo.
                      </div>
                    )}
                  </div>
                  <div className="col-md-6 mb-4">
                    <label htmlFor="confirmPassword"> Confirmar senha </label>
                    <input
                      type="password"
                      className="form-control"
                      id="confirmPassword"
                      value={confirmPassword}
                      onChange={handleConfirmPasswordChange}
                    />
                    {passwordError && <small className="text-danger">{passwordError}</small>}
                  </div>
                </div>
                <p className="card-text font-weight-bold mt-4">Configuração do serviço</p>
                <div className="row">
                  <div className="col-md-12">
                    <label htmlFor="activities">Atividades de interesse</label>
                    <input
                      type="text"
                      className={`form-control ${
                        !formSubmitted
                          ? ''
                          : atividadesIds.length > 0 || descricaoAtividades.length > 0
                          ? ''
                          : 'is-invalid'
                      }`}
                      id="activities"
                      value={atividadesName}
                      onClick={() => setShowModal(true)}
                    />
                    {descricaoAtividades.length > 0 && <small>{descricaoAtividades}</small>}
                  </div>
                </div>
                <div className="text-right">
                  <button type="button" className="btn btn-link" onClick={() => setShowModal(true)}>
                    + selecionar atividade
                  </button>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <label htmlFor="activities">Estados</label>
                    <input
                      type="text"
                      className={`form-control ${stateIsValid ? '' : 'is-invalid'}`}
                      id="activities"
                      value={selectedStates}
                      onClick={() => setShowModalState(true)}
                    />
                    {!stateIsValid && <div className="invalid-feedback">Escolha um estado</div>}
                  </div>
                </div>
                <div className="text-right">
                  <button
                    type="button"
                    className="btn btn-link"
                    onClick={() => setShowModalState(true)}
                  >
                    + selecionar estados
                  </button>
                </div>
                <p className="card-text font-weight-bold mt-4">Informações do perfil</p>
                <div className="row">
                  <div className="col-md-12 mb-4">
                    <label htmlFor="met_conlicitacao">Como conheceu o ConLicitação?</label>

                    <Select
                      name="met_conlicitacao"
                      closeMenuOnSelect
                      options={met_conlicitacao}
                      placeholder="Selecionar"
                      onChange={(selected) => {
                        setMetConlicitacao(selected?.label as any);
                      }}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 mb-4">
                    <label htmlFor="employee_quantity">Quantidade de funcionários?</label>
                    <Select
                      name="employee_quantity"
                      closeMenuOnSelect
                      options={employee_quantity}
                      placeholder="Selecionar"
                      onChange={(selected) => {
                        setEmployeeQuantity(selected?.label as any);
                      }}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 mb-4">
                    <label htmlFor="average_participation_bidding">
                      Quantas licitações participa por mês?
                    </label>
                    <Select
                      name="average_participation_bidding"
                      closeMenuOnSelect
                      options={average_participation_bidding}
                      placeholder="Selecionar"
                      onChange={(selected) => {
                        setAverageBidding(selected?.label as any);
                      }}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 mb-4">
                    <label htmlFor="billing_value">Faturamento anual com licitações?</label>
                    <Select
                      name="billing_value"
                      closeMenuOnSelect
                      options={billing}
                      placeholder="Selecionar"
                      onChange={(selected) => {
                        setAverageBilling(selected?.label as any);
                      }}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 mb-4">
                    <label htmlFor="description_services_conlicitacao">
                      Como pretende usar os serviços do ConLicitação?
                    </label>
                    <Select
                      name="description_services_conlicitacao"
                      closeMenuOnSelect
                      options={description_services_conlicitacao}
                      placeholder="Selecionar"
                      onChange={(selected) => {
                        setDescriptionService(selected?.label as any);
                      }}
                    />
                  </div>
                </div>
                {descriptionService === 'Outros' && (
                  <div className="row">
                    <div className="col-md-12 mb-4">
                      <label htmlFor="description_services_conlicitacao">
                        Descreva como pretende usar o serviço:
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder=""
                        value={descriptionUseService}
                        maxLength={100}
                        onChange={(e) =>
                          setDescriptionUseService(DOMPurify.sanitize(e.target.value))
                        }
                      />
                    </div>
                  </div>
                )}
                <p className="mt-2">
                  Ao confirmar o cadastro, declara estar ciente e de acordo com os nossos
                  <a
                    href="https://conlicitacao.com.br/termos-de-uso"
                    target="blank"
                    style={{ marginLeft: '5px' }}
                  >
                    Termos de uso
                  </a>
                </p>
                <div className="row">
                  <div className="col-md-12">
                    <button
                      type="button"
                      className={`btn btn-lg btn-block ${
                        register_request?.loading ? 'btn-warning' : 'btn-submit'
                      } `}
                      onClick={() => handleClick()}
                      disabled={register_request?.loading}
                    >
                      {register_request?.loading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          />
                          {' Cadastrando...'}
                        </>
                      ) : (
                        'Enviar cadastro'
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ModalActivities
          setShowModal={setShowModal}
          showModal={showModal}
          descricaoAtividades={descricaoAtividades}
          setDescricaoAtividades={setDescricaoAtividades}
          setAtividadesName={setAtividadesName}
          setAtividadesIds={setAtividadesIds}
        />
        <ModalStates
          setShowModalState={setShowModalState}
          showModalState={showModalState}
          selectedStates={selectedStates}
          setSelectedStates={setSelectedStates}
        />
      </div>
    </Container>
  );
};

export default RegisterView;
